interface CampoLeituraProps {
  rotulo: string;
  obrigatorio?: boolean;
  valor: string;
}

// Campo em modo leitura: só o rótulo pequeno e o valor logo abaixo, sem caixinha.
export default function CampoLeitura({ rotulo, obrigatorio, valor }: CampoLeituraProps) {
  return (
    <div>
      <p className="text-xs text-secondary-500">
        {rotulo} {obrigatorio && <span className="text-danger-600">*</span>}
      </p>
      <p className="mt-0.5 text-[15px] text-foreground-950">
        {valor || <span className="text-secondary-400">—</span>}
      </p>
    </div>
  );
}